import React from 'react';
import Styles from './betaBadge.module.scss';

const BetaBadge = () => (
  <span className={Styles.betaBeta}>Beta</span>
);


export default BetaBadge;
